/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './regimen-cycle.reducer';

export const RegimenCycleDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const regimenCycleEntity = useAppSelector(state => state.regimenCycle.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="regimenCycleDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.regimenCycle.detail.title">RegimenCycle</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.id">Id</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.name">Name</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.description">Description</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.description}</dd>
          <dt>
            <span id="cycleNumber">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.cycleNumber">Cycle Number</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.cycleNumber}</dd>
          <dt>
            <span id="duration">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.duration">Duration</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.duration}</dd>
          <dt>
            <span id="durationUnit">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.durationUnit">Duration Unit</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.durationUnit}</dd>
          <dt>
            <span id="frequency">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.frequency">Frequency</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.frequency}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.active">Active</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.regimenCycle.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{regimenCycleEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenCycle.treatmentType">Treatment Type</Translate>
          </dt>
          <dd>{regimenCycleEntity.treatmentType ? regimenCycleEntity.treatmentType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.regimenCycle.regimen">Regimen</Translate>
          </dt>
          <dd>{regimenCycleEntity.regimen ? regimenCycleEntity.regimen.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/regimen-cycle" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/regimen-cycle/${regimenCycleEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RegimenCycleDetail;
